<header class="navbar-container">
  <i
    class="pi pi-bars navbar-toggler"
    (click)="display.set(true)"
  ></i>
  <div
    class="navbar-wrapper"
    #navbar
  >
    <div class="top-nav-btns">
      @for (item of topNavItems(); track item.url) {
        <button
          pTooltip="{{ item.title }}"
          type="button"
          [routerLink]="item.url"
          routerLinkActive="active"
          (click)="item.isExternalLink && openExternalLink(item)"
        >
          <i
            [class]="item.icon"
            aria-hidden="true"
          ></i>
        </button>
      }
      <div #viewSwitcherIcon>
        <i
          #viewSwitcherIcon
          class="ti ti-grid-dots switcher-menu-icon"
          (click)="viewSwitcherMenu.toggle($event, viewSwitcherIcon)"
        ></i>
      </div>
      <p-overlayPanel
        #viewSwitcherMenu
        [dismissable]="true"
        styleClass="view-switcher-panel"
      >
        <div class="view-switcher-buttons-container">
          @for (view of appViews; track view) {
            <div
              class="view-switcher-button"
              [class.selected]="currentAppView() === view.title"
              (click)="switchAppView(view.title); viewSwitcherMenu.hide()"
            >
              <i [class]="view.icon"></i>
              <p>
                {{ view.title | titlecase }}
              </p>
            </div>
          }
        </div>
      </p-overlayPanel>
    </div>
    <div
      #accountContainer
      class="account-container"
    >
      <div
        class="profile-wrapper"
        (click)="menu.toggle($event)"
        [ngClass]="accountMenuToggle() ? 'open' : ''"
      >
        <div class="profile-pic-container">
          <div class="name-wrapper">
            <span
              class="company-name"
              title="Your company name"
              >{{ companyName() }}</span
            >
            <span
              class="full-name"
              title="Your username"
              >{{ dropdownName() }}</span
            >
          </div>
          <span class="rounded-circle"
            ><span class="initials">{{ userInitials() }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
  <p-overlayPanel
    styleClass="account-menu"
    [appendTo]="accountContainer"
    #menu
    (onShow)="toggleAccountMenu()"
    (onHide)="toggleAccountMenu()"
  >
    <ng-template pTemplate>
      @for (option of profileDropdownItems(); track option.url) {
        <div
          class="dropdown-item"
          (click)="resetBodyBlock()"
        >
          <span
            class="item"
            [routerLink]="option.url"
            routerLinkActive="active"
            (click)="
              option.action ? option.action() : undefined;
              option.label !== 'Company profile' ? resetBodyBlock() : undefined;
              menu.hide()
            "
            ><i class="dropdown-icon {{ option.icon }}"></i
            >{{ option.label || "" }}</span
          >
        </div>
      }
      <a
        href="javascript:void(0)"
        class="dropdown-item logout"
        (click)="logout(); menu.hide()"
      >
        <span class="item"
          ><i class="dropdown-icon pi pi-sign-out"></i>Logout
        </span></a
      >
    </ng-template>
  </p-overlayPanel>
</header>

<p-sidebar [(visible)]="display">
  <div class="p-sidebar-title">Menu</div>
  <div class="p-sidebar-body">
    <ul class="mobile-navbar-nav">
      @for (item of topNavItems(); track item.url) {
        <li
          class="nav-item"
          (click)="display.set(false)"
        >
          <a
            class="nav-link"
            [title]="item.title || item.label || ''"
            [routerLink]="item.url"
            routerLinkActive="active"
            (click)="item.action ? item.action() : undefined; resetBodyBlock()"
            >{{ item.title || item.label || "" }}
          </a>
          @let badge = item.badge$ | async;

          @if (badge) {
            <div class="top-nav-badge">
              <p-badge [value]="badge"></p-badge>
            </div>
          }
        </li>
      }
    </ul>
    @if (sortedSideNavItems()?.length) {
      <div class="navbar-separator">
        <span class="title">Other</span>
      </div>
    }
    <ul class="mobile-navbar-nav">
      @for (item of sortedSideNavItems(); track item.url) {
        <li
          class="nav-item"
          (click)="display.set(false)"
        >
          <a
            class="nav-link"
            [title]="item.title || item.label || ''"
            routerLinkActive="active"
            [routerLink]="item.url"
            (click)="item.action ? item.action() : undefined; resetBodyBlock()"
            >{{ item.title }}
          </a>
          @let badge = item.badge$ | async;

          @if (badge) {
            <div class="top-nav-badge">
              <p-badge [value]="badge"></p-badge>
            </div>
          }
        </li>
      }
    </ul>
    <div class="navbar-separator">
      <span class="title">Account</span>
    </div>
    <ul class="mobile-navbar-nav">
      @for (item of profileDropdownItems(); track item.url) {
        <li
          class="nav-item"
          (click)="display.set(false)"
        >
          <a
            class="nav-link"
            [title]="item.title || item.label || ''"
            (click)="
              item.action ? item.action() : undefined;
              item.label !== 'Company profile' ? resetBodyBlock() : undefined
            "
            [routerLink]="item.url"
            routerLinkActive="active"
            >{{ item.label }}
          </a>
        </li>
      }
      <li
        class="nav-item logout"
        (click)="display.set(false)"
      >
        <a
          class="nav-link"
          title="Logout"
          (click)="logout(); resetBodyBlock()"
          >Logout</a
        >
      </li>
    </ul>
  </div>
</p-sidebar>
